module.exports = __webpack_public_path__ + "img/hat-bg_10.edd4c241.png";